/**
* Created by vouill on 2019-02-05.
*/

<template>
  <div>
    <div class="content"><div class="v-container">
      Nos intervenants et auteurs
    </div>
      <v-showdown :source="vuexApiData.items[0].fields.nosIntervenants"/>
    </div>
</div></template>
<style scoped>
.v-container {
  font-weight: bold;
  font-size: 22px;
  color: #ef6c00;
  border-bottom: 4px solid #ef6c00;
  margin-bottom: 1em;
  padding-bottom: 1em;
}

.content {
  margin: auto;
  max-width: 1200px;
  margin-bottom: 2em;
  margin-top: 3em;
  padding: 1em;
}
</style>
<script>
export default {
  name: "Title",
  props: { vuexApiData: Object },
  components: {},
  data() {
    return {};
  }
};
</script>
